import { useRef, useState, useEffect } from 'react';
import { Box } from '@mui/material';
import usePageLoad from 'infrastructure/security/audit/usePageLoad';

const DefaultFooter = () => {
  const currentYear = new Date().getFullYear();
  const { getLoadTime } = usePageLoad();
  const footerRef = useRef<HTMLDivElement>(null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    if (!footerRef.current) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsFixed(entry.intersectionRatio === 1);
    });

    observer.observe(footerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <footer ref={footerRef}>
      <Box
        sx={(theme: any) => ({
          pt: '20px',
          zIndex: isFixed ? 0 : 10,
          position: isFixed ? 'fixed' : 'relative',
          bottom: isFixed ? 0 : 'auto',
          left: 0,
          width: '100%',
          padding: '3px 1rem',
          color: theme.vars.palette.common.sidebarMenuText,
          background: theme.vars.palette.common.sidebarMenuBg,
          borderTop: `1px solid ${theme.vars.palette.common.sidebarMenuActive}`,
          fontSize: '12px',
          textAlign: 'center',
          '.load-info': {
            [theme.breakpoints.up('md')]: {
              position: 'absolute',
              right: '1rem',
              bottom: '3px',
            },
            [theme.breakpoints.down('md')]: {
              marginTop: '5px',
            },
          },
        })}
      >
        © 2019 - {currentYear} Syberry Corporation. Proprietary and Confidential.
        <div className="load-info">{`Page loaded in ${((getLoadTime() || 0) / 1000).toFixed(2)} second(s)`}</div>
      </Box>
    </footer>
  );
};

export default DefaultFooter;
